//@ts-nocheck
import React, { useState, MouseEvent, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./header.scss";
import { Link, useLocation } from "react-router-dom";
import { fetchMenuItems } from "../../services/menuSlice";
import { fetchRoles } from "../../services/roleSlice";
import {
  Menu,
  MenuItem,
  Box,
  Button,
  FormControl,
  IconButton,
  // RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Logo from "../../assets/logo.svg";
import {
  IconProfile,
  // IconChange,
  IconLogout,
  IconFullScreen,
} from "../../icons/Icon";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import { BASE_URL } from "../../constants/apiConstants";
import axiosInstance from "../../api/axios";

const Header: React.FC = () => {

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<null | HTMLElement>(
    null
  );

  const [isFullScreen, setIsFullScreen] = useState(false);
  const fullScreenRef = useRef<HTMLElement | null>(null);
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [selectedSectorId, setSelectedSectorId] = useState<string | null>(null);
  const [currentMenuHeading, setCurrentMenuHeading] = useState<string | null>(
    null
  ); // Define currentMenuHeading

  const menuItems = useSelector((state: RootState) => state.menu.items);
  const [menuError, setMenuError] = useState<string | null>(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const pathName = location.pathname.split("/").pop();
  const navigate = useNavigate();
  const [selectedRoleId, setSelectedRoleId] = useState<string | number>('');
  const [roleLabel, setRoleLabel] = useState<string>('');
  const getUserInfo = () => {
    const storeduserInfo = localStorage.getItem("userInfo");
    return storeduserInfo ? JSON.parse(storeduserInfo) : null;
  };

  const userInfo = getUserInfo();

  useEffect(() => {
    const userId = userInfo?.userdetails?.userid || 2;
    let role = localStorage.getItem('roleId');
    let sector = localStorage.getItem('sectorId');
    let defaultRole, defaultSector;
    if (role && sector) {
      role = Number(role);
      defaultRole = userInfo?.userroles?.find(roleItem => roleItem?.userroleid === role);
      defaultSector = userInfo?.usersectors?.find(sectorItem => sectorItem?.id === sector);
    }
    else {
      defaultRole = userInfo?.userroles.find(role => role.defaultaccess);
      defaultSector = userInfo?.usersectors.find(sector => sector.defaultaccess);
    }
    setRoleLabel(defaultRole?.userrolename)
    const RoleId = defaultRole ? defaultRole.userroleid : 0;
    const SectorId = defaultSector ? defaultSector.id : '';
    localStorage.setItem('roleId', RoleId);
    localStorage.setItem('sectorId', SectorId);
    const sectorId = SectorId || '';
    const roleId = RoleId || 0;
    if (userId && sectorId && roleId) {
      const fetchData = async () => {
        try {
          await dispatch(fetchMenuItems({ userId, sectorId, roleId }));
          const updatedSector = userInfo?.usersectors?.find(
            (sector) => sector.id === selectedSectorId
          );
          const updatedRole = userInfo?.userroles?.find(
            (role) => role.userroleid === selectedValue
          );
          setSelectedSectorId(updatedSector ? updatedSector.id : sectorId);
          setSelectedValue(updatedRole ? updatedRole.userroleid.toString() : roleId);
        } catch (error) {
          if (error.response && error.response.status === 404) {
            console.log("Data not found (404)");
            setMenuError("Menu items not found. Please check your settings.");
          } else {
            setMenuError("An error occurred while fetching menu items.");
          }
        }
      };
      fetchData();
    }
  }, [
    dispatch,
    userInfo?.userdetails?.userid,
  ]);


  if (menuError) {
    return <div className="error">{menuError}</div>;
  }


  const handleMenuClick = (
    event: MouseEvent<HTMLElement>,
    menuHeading: string
  ) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenuHeading(menuHeading);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setAnchorE3(null);
    setCurrentMenuHeading(null);
  };

  const handleUserMenuClick = (event: MouseEvent<HTMLElement>) => {
    setUserMenuAnchorEl(event.currentTarget);
  };
  const handleUserMenuClose = () => {
    setUserMenuAnchorEl(null);
  };

  useEffect(() => {
    if (menuItems?.data?.allmodules) {
      localStorage.setItem('allmodules', JSON.stringify(menuItems?.data));
    }
    //fs logout issue
    // else{   
    //   if (menuItems?.data?.allmodules==="undefined"|| menuItems?.data?.allmodules===null) {   
    //    localStorage.clear();
    //     navigate('/error');
    //   }
   // }
    localStorage.setItem('showcost', menuItems?.data?.iscostvisible);
  }, [menuItems])

  // handle sector chnage event, update secotr-id and update new role based on sector
  const handleSectorChange = async (event: SelectChangeEvent) => {
    const newSectorId = event.target.value;
    setSelectedSectorId(newSectorId);
    localStorage.setItem("sectorId", newSectorId);
    const userId = userInfo?.userdetails?.userid || 0;
    // update roles on sector change
    const updatedRoles = await dispatch(fetchRoles({ userId, sectorId: newSectorId }));
    if (fetchRoles.fulfilled.match(updatedRoles)) {
      const storeduserInfo = localStorage.getItem("userInfo");
      const parsedUserInfo = JSON.parse(storeduserInfo);
      parsedUserInfo.userroles = updatedRoles.payload.data.roles
      localStorage.setItem("userInfo", JSON.stringify(parsedUserInfo));
    }
    const updatedDefaultRole = updatedRoles.payload.data.roles.find(role => role.defaultaccess)
    setRoleLabel(updatedDefaultRole?.userrolename)
    localStorage.setItem("roleId", updatedDefaultRole?.userroleid);
    dispatch(fetchMenuItems({ userId, sectorId: newSectorId, roleId: updatedDefaultRole?.userroleid }));

    navigate("/dashboard");

  };

  useEffect(() => {
    const storedRoleId = localStorage.getItem("userRole");
    if (storedRoleId) {
      setSelectedRoleId(JSON.parse(storedRoleId));
    }
  }, []);


  const handleRoleChange = (roleId: string | number) => {
    setUserMenuAnchorEl(null);
    localStorage.setItem("roleId", JSON.stringify(roleId));
    const userId = userInfo?.userdetails?.userid || 0;
    const savedRoleId = Number(localStorage.getItem('roleId')) || 0;
    const savedSectorId = localStorage.getItem('sectorId') || "";
    const role = userInfo.userroles.find((role) => role.userroleid === savedRoleId);
    const roleName = role ? role.userrolename : 'Unknown Role';
    setRoleLabel(roleName)

    dispatch(fetchMenuItems({ userId, sectorId: savedSectorId, roleId: savedRoleId }));
    navigate("/dashboard");
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const handleFullScreenToggle = () => {
    const elem = fullScreenRef.current || document.documentElement;
    if (!elem) return;
    if (!isFullScreen) {
      elem.requestFullscreen().then(() => setIsFullScreen(true));
    } else {
      document.exitFullscreen().then(() => setIsFullScreen(false));
    }
  };

  const isActive = (modules) => {
    if (!modules || !Array.isArray(modules)) return false;
    return modules.some(
      (module) => module?.modulename && pathName === module.modulename.toLowerCase()
    );
  };

  const handleLogout = async () => {
    const userid = localStorage.getItem("userid");
    if (!userid) {
      return;
    }

    try {
      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/Auth/LogoutUser`,
        { userid: userid }
      );
      window.location.reload()


      if (response?.data?.success) {
        toast("Logged out successfully!", { type: "success" });
        localStorage.clear();
        window.location.reload()

      } else {
        toast(response.data.message || "Logout failed. Please try again.", { type: "error" });
      }
    } catch (error) {
      console.error("Logout failed:", error);
      if (error.response) {
        console.error("Error response:", error.response); // More detailed logging
        toast(error.response.data.message || "An error occurred during logout. Please try again.", { type: "error" });
      } else {
        toast("An unexpected error occurred. Please try again.", { type: "error" });
      }
    }
  };


  return (
    <header className="flex align-items-center justify-content-between header">
      {menuError && <div className="error">{menuError}</div>}
      <div className="flex align-items-center logo-menu">
        <div className="logo">
          <Link to="/dashboard">
            <img src={Logo} alt="Logo" />
          </Link>
        </div>
        <nav className="flex align-items-center navigation">          
          {menuItems?.data?.allmodules?.filter(item => item?.menuheading)?.map((item) => (
            <div key={item.menuheading} className="menulist">
              <Button
                aria-controls={`${item.menuheading}-menu`}
                onClick={(e) => handleMenuClick(e, item.menuheading)}
                endIcon={<ExpandMore />}
                className={`menu-btn ${currentMenuHeading === item.menuheading ? "active" : ""
                  } ${item.modules && isActive(item.modules) ? "child-active" : ""}`}
              >
                {item.menuheading}
              </Button>
              <Menu
                id={`${item.menuheading}-menu`}
                anchorEl={anchorEl}
                open={currentMenuHeading === item.menuheading}
                onClose={handleMenuClose}
                className={`navigation ${currentMenuHeading === item.menuheading ? "show" : "d-none"}`}
              >
                {item.modules?.filter(module => module?.id && module?.modulename)?.map((module) => (
                  <MenuItem key={module.id} onClick={() => {
                    handleMenuClose();
                  }}>
                    <Link
                      to={`/${module.modulename.toLowerCase().replace(' ', '')}`}
                      className={
                        pathName === module.modulename.toLowerCase()
                          ? "active"
                          : ""
                      }
                    >
                      {module.moduledisplayname}
                    </Link>
                  </MenuItem>
                ))}
              </Menu>
            </div>
          ))}
        </nav>
      </div>
      <div className="right flex align-items-center">
        <div className="select-wrapper">
          <FormControl>
            <Select
              value={selectedSectorId || ""}
              onChange={handleSectorChange}
              IconComponent={ExpandMore}
              disabled={userInfo?.usersectors?.length === 1}
              renderValue={() => {
                const selectedSector = userInfo?.usersectors?.find(
                  (sector) => sector.id === selectedSectorId
                );
                return selectedSector ? selectedSector.sectorname : "";
              }}
              MenuProps={{
                MenuListProps: {
                  id: "custom-select",
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
              }}
            >
              {userInfo?.usersectors?.map((sector) => (
                <MenuItem
                  key={sector.id}
                  value={sector.id}
                  className="radio-list"
                  disableRipple
                >
                  <FormControlLabel
                    value={sector.sectorname}
                    control={<Radio checked={selectedSectorId === sector.id} />}
                    label={sector.sectorname}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <IconButton
          className="full-screen"
          disableRipple
          onClick={handleFullScreenToggle}
        >
          <IconFullScreen />
        </IconButton>
        <Box display="flex" alignItems="center" className="user-menu">
          <FormControl>
            <Box
              className="flex align-items-center user"
              onClick={handleUserMenuClick}
            >
              <div className="icon-wrap">
                <IconProfile />
              </div>
              <Box className="flex user-data" flexDirection="column">
                <h6>{userInfo?.userdetails?.username || "Guest"}</h6>
                <p className="small">
                  {roleLabel}
                </p>
              </Box>
              <IconButton
                disableRipple
                className={`${Boolean(userMenuAnchorEl) ? "active" : ""}`}
              >
                <ExpandMore />
              </IconButton>
            </Box>

            <Menu
              anchorEl={userMenuAnchorEl}
              open={Boolean(userMenuAnchorEl)}
              onClose={handleUserMenuClose}
              className="user-menu-list"
            >
              {userInfo?.userroles?.length > 0 ? (
                userInfo?.userroles?.map((userRole: any, i: number) => (
                  <MenuItem key={userRole.id, i}>
                    <Button
                      onClick={() => handleRoleChange(userRole.userroleid)}
                      className={selectedRoleId === userRole.userroleid ? "active" : ""}
                    >
                      {userRole.userrolename}
                    </Button>
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No roles available</MenuItem>
              )}

              <MenuItem
                onClick={() => {
                  handleLogout();
                  handleUserMenuClose();
                }}
                disableRipple
              >
                <Button disableRipple className="logout-button">
                  <span className="icons">
                    <IconLogout />
                  </span>
                  Logout
                </Button>
              </MenuItem>
            </Menu>
          </FormControl>
        </Box>
      </div>
    </header>
  );
};

export default Header;
